import { QueryCache, QueryClient, MutationCache } from '@tanstack/react-query';

import { ENV } from '@/shared/config';

const isProd = ENV.IS_PROD_MODE && ENV.IS_PROD_RUNTIME;

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (!isProd) {
        console.error('Query Error:', {
          error,
          queryKey: query.queryKey,
          queryHash: query.queryHash
        });
      }
    }
  }),
  mutationCache: new MutationCache({
    onError: (error, variables, _context, mutation) => {
      if (!isProd) {
        console.error('Mutation Error:', {
          error,
          variables,
          mutationKey: mutation.options.mutationKey
        });
      }
    }
  }),
  defaultOptions: {
    queries: {
      gcTime: Infinity,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: false
    }
  }
});
